import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { AlcmeonContextService } from 'src/app/core/alcmeon-context/alcmeon-context.service';
import { AsyncRequestService } from 'src/app/core/async-request/async-request.service';
import { API_URL_COMPANIES, BasicService } from '../../services/basic.service';
import { ErrorHandlingService } from '../../services/error-handling.service';
import { MediasService } from '../../services/medias.service';
import { MassMessagingError } from './models';

@Injectable({
  providedIn: 'root',
})
export class ErrorsPlaceholderCellService {
  constructor(
    private httpClient: HttpClient,
    private alcmeonContextService: AlcmeonContextService,
    private tSAsyncRequestService: AsyncRequestService,
    private errorHandlingService: ErrorHandlingService,
    private basicService: BasicService,
    private mediasService: MediasService
  ) {}

  findAll(path: string, id: number): Observable<MassMessagingError[]> {
    return this.httpClient
      .get<MassMessagingError[]>(`${API_URL_COMPANIES}/${this.alcmeonContextService.companyId}/${path}/${id}/errors`)
      .pipe(this.errorHandlingService.catchAlertAndThrowHttpError());
  }

  exportErrorsAsExcel(path: string, id: number) {
    this.basicService.showSpinner();
    this.tSAsyncRequestService
      .get(`${API_URL_COMPANIES}/${this.alcmeonContextService.companyId}/${path}/${id}/export-errors`)
      .pipe(finalize(() => this.basicService.hideSpinner()))
      .subscribe({
        next: (data: any) => {
          const { content, content_type, content_filename } = data;
          this.mediasService.downloadBinaryBase64(content, content_type, content_filename);
        },
      });
  }
}
